import React from "react";
import axios from "axios";
import TSnackBar from "../TSnackBar";

const TGlobalMessage = () => {
    const [message, setMessage] = React.useState(undefined);
    const [loading, setLoading] = React.useState(undefined);
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const url = `${process.env.REACT_APP_SPECTRUMWEB_URL}/api/messages/FPET`;
                const response = await axios.get(url);
                const message = response.data;

                if (typeof message !== "undefined" && message !== "") {
                    setMessage(response.data);
                    setVisible(true);
                }
            } catch (err) {
                console.log("Failed to get global FPET message");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading && !visible) {
        return null;
    }

    if (visible) {
        return (
            <TSnackBar
                open={visible}
                message={message}
                onClose={() => setVisible(false)}
            />
        );
    }
};

export default TGlobalMessage;
